import { cidadesVizinhas, listar } from "./cidades.js";

export const grupos = [
  {
    rotulo: "Sobre a Hawx",
    titulo: "Quem somos e onde atendemos",
    perguntas: [
      {
        p: "Onde a Hawx atende?",
        r: `A Hawx fica em Orleans, no sul de Santa Catarina. O diagnóstico é presencial em Orleans e nas cidades vizinhas, como ${listar(cidadesVizinhas)}. Desenvolvimento, implantação e suporte acontecem com acompanhamento à distância, o que permite atender empresas de qualquer cidade de Santa Catarina.`,
      },
      {
        p: "Quem desenvolve os sistemas?",
        r: "Uma equipe de profissionais experientes, com vários anos de trabalho em desenvolvimento de software e automação de processos. O diagnóstico, o desenvolvimento, a implantação e o suporte são feitos pela mesma equipe, que acompanha o projeto do início ao fim.",
      },
      {
        p: "Que tipo de software a Hawx desenvolve?",
        r: "Sistemas sob medida para a operação de cada empresa: sistemas web, aplicativos para celular e programas para computador, além de automações que conectam as ferramentas que a empresa já usa. Não vendemos sistema pronto nem produto de prateleira. Cada projeto é feito para o processo do cliente.",
      },
      {
        p: "Para que tipo de empresa a Hawx trabalha?",
        r: "Empresas e empreendedores que precisam de um sistema próprio, feito para o jeito como trabalham. Os pedidos mais comuns são gestão de clientes e pedidos, controle de estoque e produção, relatórios e painéis e integração com as ferramentas que a empresa já usa.",
      },
    ],
  },
  {
    rotulo: "Projeto",
    titulo: "Como começa, quanto custa e quanto tempo leva",
    perguntas: [
      {
        p: "Como começa um projeto com a Hawx?",
        r: "Com uma conversa no WhatsApp, sem compromisso e sem formulário. Depois vem o diagnóstico presencial, a proposta com orçamento gratuito, escopo e prazo definidos, e só então o desenvolvimento, a implantação e o suporte.",
      },
      {
        p: "O diagnóstico tem custo?",
        r: "A conversa inicial é sem compromisso e o orçamento é gratuito. Se o diagnóstico tiver custo, ele é combinado antes da visita.",
      },
      {
        p: "Sou obrigado a contratar o sistema depois do diagnóstico?",
        r: "Não. O plano do que resolver primeiro é seu. Seguir com desenvolvimento ou automação é uma decisão à parte.",
      },
      {
        p: "Quanto custa um software sob medida?",
        r: "Depende do que o sistema precisa fazer. Por isso a primeira etapa é o diagnóstico, e a proposta vem com orçamento gratuito, escopo e prazo definidos antes de qualquer trabalho começar.",
      },
      {
        p: "Quanto tempo leva?",
        r: "O prazo é definido na proposta, de acordo com o que o sistema precisa fazer. Você acompanha o andamento durante todo o desenvolvimento.",
      },
    ],
  },
  {
    rotulo: "Sistema e automação",
    titulo: "O que você recebe e o que acontece depois",
    perguntas: [
      {
        p: "Qual a diferença entre um software sob medida e um sistema pronto?",
        r: "O sistema pronto obriga a operação a se adaptar a ele. O software sob medida é feito para o jeito como a empresa já trabalha, com os campos, as etapas e os relatórios que a equipe usa, e cresce junto com o negócio.",
      },
      {
        p: "O sistema funciona no celular?",
        r: "Sim. Você escolhe onde o sistema vai ser usado: no navegador, no celular ou no computador da operação. O design é responsivo e funciona bem em qualquer tela.",
      },
      {
        p: "Preciso trocar os sistemas que já uso?",
        r: "Não. A automação conecta o que a empresa já usa, e um sistema novo conversa com as ferramentas existentes em vez de substituir tudo. Trocar de ferramenta só acontece se fizer sentido para você.",
      },
      {
        p: "Que tipo de tarefa vale a pena automatizar?",
        r: "A que se repete todo dia e depende de alguém lembrar: lançar, conferir, avisar, consolidar. Quanto mais repetitiva, maior o ganho.",
      },
      {
        p: "E depois da entrega, fico sem apoio?",
        r: "Não. O sistema é implantado na sua operação, com os dados e as pessoas de verdade, e você tem suporte depois da entrega. Se o processo mudar, o sistema e a automação são ajustados.",
      },
    ],
  },
];
